module.exports = __webpack_public_path__ + "img/final-bg.fe68ba5d.png";